export default [
  {
    path: '/supplier/edit',
    name: 'supplierEdit',
    component: () => import('../views/supplierForm/index.vue'),
    meta: {
      rules: 0,
    },
  },
  {
    path: '/supplier/add',
    name: 'supplierAdd',
    component: () => import('../views/supplierForm/index.vue'),
    meta: {
      rules: 0,
    },
  }
]